// extracted by mini-css-extract-plugin
module.exports = {"Scollbar":"Scollbar_Scollbar__tUoLE"};